import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
@Module({ namespaced: true })
class GlobalValues extends VuexModule {
  public isLoading?: boolean = false;
  public notificationMessage?: string = undefined;

  @Mutation
  public updateLoading (newVal: boolean): void {
    this.isLoading = newVal;
  }

  @Action
  public setLoading (newVal: boolean): void {
    this.context.commit('updateLoading', newVal);
  }

  @Mutation
  public updateNotification (message?: string): void {
    this.notificationMessage = message;
  }

  @Action
  public setNotification (message?: string): void {
    this.context.commit('updateNotification', message);
  }
}
export default GlobalValues;
